export default {"src":"/_next/static/image/public/images/ic_lab_test_order.c734ab46fb78bc0fa53abdc0352f7051.svg","height":167,"width":126};